import dayjs from "@lib/dayjs";
import {
  jobMembersProfile,
  unseenMessageCount,
} from "../../endpoints/job.service";
import {
  RESET_UNSEEN_MESSAGE_COUNT,
  SET_CHAT_RECEIVER_DETAILS,
  SET_JOB_MEMBERS_PROFILE,
  SET_UNSEEN_MESSAGE_COUNT,
} from "./action.types";

export const setUnseenMessageCount = (count) => {
  return {
    type: SET_UNSEEN_MESSAGE_COUNT,
    payload: count,
  };
};

export const resetUnseenMessageCount = () => ({
  type: RESET_UNSEEN_MESSAGE_COUNT,
});

export const setJobMembersProfile = (data) => ({
  type: SET_JOB_MEMBERS_PROFILE,
  payload: data,
});

export const setChatReceiverDetails = (data) => ({
  type: SET_CHAT_RECEIVER_DETAILS,
  payload: data,
});

export const fetchJobMessagesProfile = () => {
  return async (dispatch) => {
    try {
      const { data, success } = await jobMembersProfile({});
      if (success) {
        //Sorting recentRooms inside each profile
        const profilesWithSortedJobs = data?.data?.map((profile) => {
          const sortedRecentRooms = [...profile.recentRooms].sort((a, b) => {
            const aTime = a.lastActivityAt
              ? dayjs(a.lastActivityAt)
              : null;
            const bTime = b.lastActivityAt
              ? dayjs(b.lastActivityAt)
              : null;

            if (aTime && bTime) return bTime.diff(aTime);
            if (aTime) return -1;
            if (bTime) return 1;
            return 0;
          });

          return {
            ...profile,
            recentRooms: sortedRecentRooms,
          };
        });
        //Sorting outer profiles by latest message across their recentRooms
        const sortedProfiles = profilesWithSortedJobs?.sort((a, b) => {
          const getLatestMessageTime = (jobs) =>
            jobs?.reduce((latest, job) => {
              const msgTime = job.lastActivityAt
                ? dayjs(job.lastActivityAt)
                : null;
              return msgTime && (!latest || msgTime.isAfter(latest))
                ? msgTime
                : latest;
            }, null);
          const latestA = getLatestMessageTime(a?.recentRooms);
          const latestB = getLatestMessageTime(b?.recentRooms);

          if (latestA && latestB) return latestB.diff(latestA);
          if (latestA) return -1;
          if (latestB) return 1;
          return 0;
        });

        dispatch(setJobMembersProfile(sortedProfiles));
      }
    } catch (error) {
      console.error("Error fetching job message profile:", error);
    }
  };

};

export const fetchUnseenMessageCount = () => {
  return async (dispatch) => {
    try {
      const { data, success } = await unseenMessageCount();

      if (success) {
        dispatch(setUnseenMessageCount(data));
      }
    } catch (error) {
      console.error("Error fetching unseen message count:", error);
    }
  };
};
